module.exports = __webpack_public_path__ + "img/bin.084b9026.svg";